// extracted by mini-css-extract-plugin
export var discription = "index-module--discription--03077";
export var missionTitle = "index-module--missionTitle--58a5d";
export var root = "index-module--root--b2d7c";
export var subTitle = "index-module--subTitle--5ff93";
export var text = "index-module--text--79272";
export var title = "index-module--title--07325";